import { NgClass, NgStyle } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule, Platform } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { AnimationOptions, LottieComponent } from "ngx-lottie";
import { SocialService } from "src/app/services/social.service";

@Component({
  selector: "app-unsplash-photo-popup",
  templateUrl: "./unsplash-photo-popup.component.html",
  styleUrls: ["./unsplash-photo-popup.component.scss"],
  standalone: true,
  imports: [
    LottieComponent,
    IonicModule,
    NgStyle,
    NgClass,
    TranslatePipe,
  ],
})
export class UnsplashPhotoPopupComponent {
  public result: string;
  public confirmRemoveImg: boolean;
  public imageData: Data;
  public removePopup: boolean;
  public bottomBarToggle: boolean;
  public imageURL: string;
  selectedLanguage: string;
  public spanish: boolean;
  public showAnimation: boolean;
  public showremoveAnimation: boolean;
  public userId: string;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: Data,
    public dialogRef: MatDialogRef<UnsplashPhotoPopupComponent>,
    private analytics: AngularFireAnalytics,
    public SocialServices: SocialService,
    private platform: Platform,
    public translate: TranslateService,
    private authService: AuthService
  ) {
    // This variables has been used to contain the image data and image URL
    try {
      this.imageData = data;
      this.imageURL = this.imageData.imageURL.replace(/\s/g, '%20');
      // This variables has been used to contain the boolean value for remove popup class  
      this.removePopup = false;
      this.bottomBarToggle = true;
      if (this.platform.is("android")) {
        this.removePopup = true;
      }
    }
    catch (err) {
      // Handle error
      throw new Error(`Image data not fount:${err}`);
    }
    //  This method has been used to get the selected language
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        translate.use(l ? l : "en");
        if (l == "es") {
          this.spanish = true;
        }
      },
      (err) => {
        return err;
      }
    );
  }

  // json icons path
  public options: AnimationOptions = {
    path: "./../../../../assets/remove.json",
    loop: false,
  };
  public reaction_options: AnimationOptions = {
    path: "./../../../../assets/heartani.json",
    loop: false,
  };



  async ngOnInit() {
    await this.authService.getUid("UnsplashPhotoPopupComponent").then((uid) => {
      this.userId = uid;
    })
    this.analytics.logEvent("syndicate_member_modal", { userId: this.userId });
  }

  // This method has been used to close the popup
  close() {
    this.dialogRef.close();
    this.bottomBarToggle = true;
  }
  //  This method has been used to close the popup
  RemoveImg(imageData: Data) {
    setTimeout(() => {
      this.dialogRef.close();
    }, 2000); // 2000 milliseconds = 2 seconds
    this.SocialServices.deleteImage(imageData);
    this.removeAnimation();
  }

  likeAnimation() {
    this.showAnimation = true;
    setTimeout(() => {
      this.showAnimation = false;
    }, 3000);
  }
  removeAnimation() {
    this.showremoveAnimation = true;
    setTimeout(() => {
      this.showremoveAnimation = false;
    }, 3000);
  }
  // This method has been used to toggle remove popup
  public async removeToggle() {
    this.confirmRemoveImg = true;
    this.bottomBarToggle = false;
  }
  // This method has been used to toggle the liked images or unlike images
  isChangeLimitAccessToggle(isLiked: boolean) {
    this.SocialServices.albumLikedImages(this.imageData, isLiked);
    this.likeAnimation();
  }
  // This method has been used to get the width of the image wrapper
  public getWidth() {
    const parent = document.getElementsByClassName('image-wrapper')
    if (parent && parent.length) {
      return parent[0].clientWidth + 2;
    }
    return 'inherit';

  }
}
